<template>
  <div class="flex cursor-pointer" @click="clickedHandler()">
    <i id="card-arrow" class="fa-solid fa-chevron-down fa-lg text-orange-400 mr-2"></i>
    <slot></slot>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isClosed: true
    }
  },

  mounted() {
    window.addEventListener('resize', () => {
      const element = document.getElementById(this.id);
      element.style.height = 'auto'
      this.setHeights()
    });
  },

  props: {
    id: String
  },

  methods: {
    clickedHandler: function () {
      this.isClosed = !this.isClosed;
      this.setHeights();
    },

    setHeights: function () {
      if (document.getElementById(this.id)) {
        let element = document.getElementById(this.id);
        if (!this.isClosed) {
          document.getElementById('card-arrow').classList.add('active')
          element.style.height = element.scrollHeight+'px';
        } else {
          document.getElementById('card-arrow').classList.remove('active')
          element.style.height = 0+'px';
        }
      }
    }
  }
}

</script>
